import { apiConfig } from "core-lib/config/config";
import { Source } from "core-lib/constants/sourceSKU";
import { getMethod } from "core-lib/utils/apiV2";
import { createAction } from "redux-actions";
import { call, put, takeEvery } from "redux-saga/effects";
import { formatVehicleList } from "../utils";
import {
  GET_CHARIOT_FAILURE,
  GET_CHARIOT_REQUEST,
  GET_CHARIOT_START,
  GET_CHARIOT_SUCCESS,
} from "./type";

export const getVehicleStart = createAction(GET_CHARIOT_START);
export const getVehicleRequest = createAction(GET_CHARIOT_REQUEST);
export const getVehicleSuccess = createAction(GET_CHARIOT_SUCCESS);
export const getVehicleFailure = createAction(GET_CHARIOT_FAILURE);

// GET CHARIOT
function* getVehicle(reqBody) {
  yield put(getVehicleRequest());

  let params = null;
  if (reqBody?.payload && reqBody?.payload !== Source.Challan) {
    params = { source: reqBody.payload };
  }

  try {
    const { response, error } = yield call(getMethod, {
      endPoint: `${apiConfig("vehicle", "v3")}/filteredVehicleList/`,
      params,
    });
    if (response) {
      yield put(
        getVehicleSuccess(
          formatVehicleList(response?.data?.vehicle_data, reqBody?.payload)
        )
      );
    }
    if (error) {
      yield put(getVehicleFailure(error));
    }
  } catch (error) {
    yield put(getVehicleFailure(error));
  }
}

export function* watchVehicle() {
  yield takeEvery(GET_CHARIOT_START, getVehicle);
}
